/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React, { FC } from "react";
import { Badge, BADGE_POSITION } from "../Badge";
import { DesignContext } from "@adapptio/lib-blueprint";
import { ResourceService } from "../../../resources/ResourceService";
import { getReferenceListData } from "./getReferenceListData";

export interface IReferenceCountBadgeProps {
	resourceId: string;
	resourceService: ResourceService;
	dCtx: DesignContext;
}

export const ReferenceCountBadge: FC<IReferenceCountBadgeProps> = ({ resourceId, resourceService, dCtx }) => {
	const { dependsOn, referencedBy } = getReferenceListData(resourceId, resourceService, dCtx);

	return <Badge content={String(dependsOn.length + referencedBy.length)} position={BADGE_POSITION.END} />;
};
